import { Image } from '@shared/api/media/media.interface';

/** 배너 클릭 시 동작 (docs/gift-store-banner-spec.md §1) */
export enum GiftStoreBannerLinkType {
  None = 'None', // 클릭 없음
  GiftItemBrand = 'GiftItemBrand', // 그 브랜드 상품이 있는 위치로 스크롤
  DeliveryCategory = 'DeliveryCategory', // 배송 카테고리(+하위분류) 위치로 스크롤
  GiftItemInfo = 'GiftItemInfo', // 그 원상품의 상세 페이지로 이동
}

/** 링크 안 ref는 서버가 populate 하지 않고 id 문자열로 내려준다 */
export type GiftStoreBannerLink = {
  type: GiftStoreBannerLinkType;
  giftItemBrand?: string | null;
  giftDeliveryCategory?: string | null;
  subCategory?: string | null;
  giftItemInfo?: string | null;
};

/** 고객 스토어용 — 공개 API는 이 필드만 내려준다 */
export type GiftStoreBannerPublic = {
  _id: string;
  image?: Image | string | null;
  alt?: string;
  link?: GiftStoreBannerLink | null;
};

/** 관리자용 전체 문서 (startAt/endAt은 axios 날짜 리바이버 때문에 런타임엔 Date) */
export type GiftStoreBannerData = GiftStoreBannerPublic & {
  title: string;
  isEnabled?: boolean;
  order?: number;
  startAt?: Date | string | null;
  endAt?: Date | string | null;
  bugoBrands?: (string | { _id: string })[];
  createdAt?: Date | string;
  updatedAt?: Date | string;
};

export type GiftStoreBannerCreate = {
  title: string;
  image: string; // Image id
  alt?: string;
  isEnabled: boolean;
  startAt: string | null; // ISO
  endAt: string | null; // ISO
  bugoBrands: string[]; // 빈 배열 = 전체 상조
  link: GiftStoreBannerLink; // 수정 시에도 통째로 보낸다 (이전 대상 id 잔존 방지)
};

export type GiftStoreBannerUpdate = Partial<GiftStoreBannerCreate>;
